import {
    RAISE_TICKET_REQUEST,
    RAISE_TICKET_SUCCESS,
    RAISE_TICKET_ERROR,
    RAISE_TICKET_ERROR_RESET
} from '../actionType';

export const postTicketRequest = (value:any) => ({
    type: RAISE_TICKET_REQUEST,
    value
});

export const postTicketSuccess = (data:any) =>({
    type: RAISE_TICKET_SUCCESS,
    payload:data
});

export const postTicketError = (error:any) => ({
    type: RAISE_TICKET_ERROR,
    payload:error
});
export const postTicketErrorReset = () => ({
    type: RAISE_TICKET_ERROR_RESET,
});